export const TUTORIAL_TARGET_MENU_ITEM_PROFILE = "TUTORIAL_TARGET_MENU_ITEM_PROFILE"
export const TUTORIAL_TARGET_PROFIL_TAB_INFO_PERSO = "TUTORIAL_TARGET_PROFIL_TAB_INFO_PERSO"
export const TUTORIAL_TARGET_PROFIL_EDIT_INFO_PERSO = "TUTORIAL_TARGET_PROFIL_EDIT_INFO_PERSO"
export const TUTORIAL_TARGET_PROFIL_TAB_DOCS = "TUTORIAL_TARGET_PROFIL_TAB_DOCS"
export const TUTORIAL_TARGET_PROFIL_DOCS_PERSO = "TUTORIAL_TARGET_PROFIL_DOCS_PERSO"
export const TUTORIAL_TARGET_PROFIL_DOCS_PRO = "TUTORIAL_TARGET_PROFIL_DOCS_PRO"
export const TUTORIAL_TARGET_PROFIL_TAB_SETTINGS = "TUTORIAL_TARGET_PROFIL_TAB_SETTINGS"
